import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
//import { OrderPlanner } from '../../../common/OrderPlanner';
//import { PurchaseOrderService } from '../../../services/index';
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { agentOutwardService } from "../../../services/agentoutward.service";
import { Combo2Service } from "../../../services/index";

@Component({
  selector: "addEditAgentInward",
  templateUrl: "./addEditAgentInward.html",
})
export class addEditAgentInwardComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  finyearList = [];
  List = ["R & D", "FAIR", "SALES PERSON", "CONFERENCE", "SUSPENSE", "FACTORY"];
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;

  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  mode: string;
  owref_no: number;
  saveEvent: any;
  agentList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  agentStock = [];

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;

    if (this.mode == "Edit") {
      this.editInvoiceList();
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  finCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private agentowservice: agentOutwardService,
    private combo2Service: Combo2Service
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }

  ngOnInit() {
    this.finyearCombo();
    this.getSalesAgent();
    this.tableScroll();
  
    this.invoicedata.mode = this.mode;
    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAutoNumber();
  
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#invoicedata.finYear").focus();
    }, 100);
  }

  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  onDeleteRow($event, fld, bc, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 1) {
          that.data.invoiceList.splice(ind, 1);
          that.calctot();
        }
      },
      function (dismiss) {}
    );
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //   var temp = ["Core", "All"];
      //   that.finyearList.concat(temp);
      that.finCtrl.setValue(res.data[0].fin_id);
      that.invoicedata.fin_id = res.data[0].fin_id;
      that.invoicedata.finyear = res.data[0].finyear;
    });
  }
  onChangeFinyear(finyear) {
    let curfin = _.filter(this.finyearList, { finyear: finyear });
    this.invoicedata.fin_id = curfin[0]["fin_id"];
    this.invoicedata.owref_no = "";
    this.invoicedata.type = "";
    this.invoicedata.agent_name = "";
    this.invoicedata.agent_id = "";
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    this.agentowservice.getAutoNumber().then((res: any) => {
      this.invoicedata.ref_no = res;
    });
  }

  getSalesAgent() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.agentowservice.getSalesAgent(params).then((res: any) => {
      this.agentList = res;
    });
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  checkBarcode(code) {
    // if (this.invoicedata.agent_name == undefined) {
    //     swal("Make sure that the agent name entered");
    //     return false;
    // }
    if (code.length == 7) {
      let params = {
        barcode: code,

      };
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        code = parseInt(code);
        this.data.invoiceList[i].barcode = parseInt(
          this.data.invoiceList[i].barcode
        );
        if (this.data.invoiceList[i].barcode == code) {
          setTimeout(() => {
            this.invoicedata.barcode = "";
          }, 500);

          swal("Barcode Already Exists");
          swal({
            title: "Barcode Already Exists",
            timer: 1000,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
          });
          return;
        }
      }
      let that = this;
      that.agentowservice.checkBarcodeInward(params).then((res: any) => {
        let exist = false;
        let type_check = '';
        if(res.success == true){
             exist = true;
             type_check =  res.stockdata[0].type;
        }
        if (!exist) {
          swal({
            title: "Selected Design is not in this sales person outward stock",
            type: "warning",
          });
          that.invoicedata.barcode = "";
          return
        } 
        if (type_check != that.invoicedata.type) {
          swal({
            title: "Selected Design Not Matched" ,
            type: "warning",
          });
          that.invoicedata.barcode = "";
        } 
        else {
          if (res.data.length == 0) {
            swal({
              title: "Selected Design is invalid",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000,
            });
            let invalidData = {
              barcode: code,
              type: "invoice",
            };
            that.invalidList.push(invalidData);
            that.invoicedata.barcode = "";
            return;
          }
      
          let row = Object.assign(
            {
              f34: 0,
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h34: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
              owref_no : 0,
              ow_aoid : 0,
              type : '',
              agent_name : '',
              agent_id : 0,
              qly_type : ''
            },
            res.data
          );
          row.stockid = res.data.stockid;
          row.owref_no = res.stockdata[0].ref_no;
          row.ow_aoid = res.stockdata[0].aoid;
          row.type = res.stockdata[0].type;
          row.agent_id = res.stockdata[0].agent_id;
          row.agent_name = res.stockdata[0].agent_name;

          let check_damage = res.data.size.split("");
          if(check_damage[0] == "D"){
            let temp_size = check_damage.slice(1);
            row.size = temp_size.join("");
            console.log(row.size);
            row[row.size.toLowerCase()] = 1;
            row.qly_type = "DAMAGE"
          }
          else{
              row[row.size.toLowerCase()] = 1;
              row.qly_type = "FRESH";

          }
         
          row[row.size.toLowerCase()] = 1;
          row.fqty =
            row.f34 + row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
          row.hqty =
            row.h34 + row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
          row.totqty = row.hqty + row.fqty;
          that.data.invoiceList.push(row);
          console.log(that.data.invoiceList);
          that.calctot();
          that.invoicedata.barcode = "";
        }
      });
    }
  }

  search(barcode) {
    for (let i = 0; i < this.agentStock.length; i++) {
      if (this.agentStock[i].barcode == barcode) {
        return this.agentStock[i];
      }
    }
  }

  oncheckemptyrow() {
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;
    this.onSaveInvoice();
  }

  onSaveInvoice() {
    // if (this.invoicedata.owref_no == "") {
    //   swal("Make Sure that the OW Reference No is entered");
    //   return false;
    // }
    let types = this.invoicedata.type;
    let isAgent: number = 1;
    // if (types == "SALES PERSON" || types == "SUSPENSE") {
    //   if (this.invoicedata.agent_name == undefined) {
    //     swal("Make sure that the sales person name entered");
    //     isAgent = 0;
    //   }
    // }
    if (isAgent) {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.agentowservice
          .saveUpdateAgentInwardRecord(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  // onSelectOW(barcode) {
  //   let params = {
  //     barcode: barcode,
  //     fin_id: this.invoicedata.fin_id,
  //   };
  //   let that = this;
  //   this.agentowservice.getAgentStock(params).then((res: any) => {
  //     that.agentStock = res.data;
  //     if (res.total <= 0) {
  //       this.invoicedata.agent_name = "";
  //       this.invoicedata.type = "";
  //       this.invoicedata.agent_id = "";
  //       swal("Check Outward Stock Reference no.");
  //     } else {
  //       if (res.data[0].type == "SALES PERSON" || res.data[0].type == "SUSPENSE") {
  //         this.invoicedata.agent_name = res.data[0].agent_name;
  //         this.invoicedata.agent_id = res.data[0].agent_id;
  //       }
  //       this.invoicedata.type = res.data[0].type;
  //     }
  //     that.calctot();
  //   });
  // }

  editInvoiceList() {
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
    params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
    let that = this;
    params = {
      start: 0,
      limit: 100,
      page: 1,
      aiid: this.invoicedata.aiid,
    };
    this.agentowservice.getAgentStockDetail(params).then((res: any) => {
      that.data.invoiceList = res.data;
      that.invoicedata.dcdt = res.data[0].aodt;
      that.invoicedata.type = res.data[0].type;
      if (res.data[0].type == "SALES PERSON" || res.data[0].type == "SUSPENSE") {
        that.invoicedata.agent_name = res.data[0].agent_name;
        that.invoicedata.agent_id = res.data[0].agent_id;
      }
      that.calctot();
    });
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.fqty = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.hqty = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.totqty = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/agentInward/addEditAgentInward.ts